import { useSelector } from 'react-redux';
import { useContext } from 'react';
import { getAlerts } from 'store/alerts/selectors';
import Alert from 'components/molecules/Alert/Alert';
import { ResolutionTypeContext } from 'contexts/ResolutionTypeContext';
import { AlertsContainer } from './AlertsPortal.style';

const AlertsPortal = () => {
  const alerts = useSelector(getAlerts);
  const { isPhoneResolution } = useContext(ResolutionTypeContext);

  return (
    <AlertsContainer $isMobile={isPhoneResolution}>
      {alerts.map(alert => (
        <Alert key={alert.id} alert={alert} />
      ))}
    </AlertsContainer>
  );
};

export default AlertsPortal;
